export const openMenu = function (code) {
  try {
    vm.$store.state.menu.open(code)
  } catch {
    console.log('menu.js => 打开菜单失败')
  }
}
